var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.formLogicLoading,
          expression: "formLogicLoading",
        },
      ],
      staticClass: "add-container",
    },
    [
      _c(
        "div",
        [
          _c("el-page-header", {
            staticClass: "mb-10 fw-bold",
            attrs: { content: (_vm.ruleId ? "编辑" : "新增") + "行动规则" },
            on: { back: _vm.goBack },
          }),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", { staticClass: "fw-bold" }, [_vm._v("基本设置")])]
          ),
          _c(
            "el-form",
            {
              ref: "formLogic",
              attrs: {
                model: _vm.formLogic,
                rules: _vm.workLogicRule,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规则名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "35%" },
                    model: {
                      value: _vm.formLogic.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formLogic, "name", $$v)
                      },
                      expression: "formLogic.name",
                    },
                  }),
                ],
                1
              ),
              _c("dt-form-item", {
                staticClass: "formkey-item",
                attrs: {
                  prop: "formKey",
                  label: _vm.searchParamFormKey.label,
                  inputType: _vm.searchParamFormKey.type,
                  propKey: _vm.searchParamFormKey.propKey,
                  options: _vm.searchParamFormKey.options,
                  componentAttr: _vm.searchParamFormKey.attrs,
                  valueRepeat: _vm.searchParamFormKey.valueRepeat,
                },
                model: {
                  value: _vm.formLogic.formKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.formLogic, "formKey", $$v)
                  },
                  expression: "formLogic.formKey",
                },
              }),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "35%" },
                    attrs: { type: "textarea", rows: 4 },
                    model: {
                      value: _vm.formLogic.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formLogic, "description", $$v)
                      },
                      expression: "formLogic.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "fw-bold" }, [_vm._v("触发条件")]),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleClickAddLogic },
                },
                [_vm._v("新增条件 ")]
              ),
            ],
            1
          ),
          _vm.formLogic.formKey
            ? _c("logic-form", {
                ref: "logicForm",
                attrs: {
                  formKey: _vm.formLogic.formKey,
                  conditionList: _vm.conditionList,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", { staticClass: "fw-bold" }, [_vm._v("生成工单")])]
          ),
          _c(
            "el-form",
            {
              ref: "triggerForm",
              attrs: {
                model: _vm.triggerList,
                inline: true,
                rules: _vm.triggerFormRule,
              },
            },
            [
              _c("div", { staticClass: "mb-10" }, [_vm._v("第一处理人")]),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("span", [_vm._v("选择处理人 ")]),
                      _c(
                        "el-select",
                        {
                          on: {
                            change: function ($event) {
                              ;(_vm.triggerList.firstProcessorId = []),
                                _vm.firstProcessorTypeChange()
                            },
                          },
                          model: {
                            value: _vm.triggerList.firstProcessorType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.triggerList,
                                "firstProcessorType",
                                $$v
                              )
                            },
                            expression: "triggerList.firstProcessorType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "门店角色", value: "role" },
                          }),
                          _c("el-option", {
                            attrs: { label: "指定用户", value: "user" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "firstProcessorId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.triggerList.firstProcessorId,
                            callback: function ($$v) {
                              _vm.$set(_vm.triggerList, "firstProcessorId", $$v)
                            },
                            expression: "triggerList.firstProcessorId",
                          },
                        },
                        _vm._l(_vm.firstProcessorOptions, function (option) {
                          return _c("el-option", {
                            key: option.id,
                            attrs: {
                              label: option.name || option.roleName,
                              value: option.id,
                            },
                          })
                        }),
                        1
                      ),
                      _c("span", { staticStyle: { color: "#ccc" } }, [
                        _vm._v(
                          " 如果选择的角色包含多人，则指定其中任意一人处理"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    [
                      _c("span", [_vm._v("处理人为空时 ")]),
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.handleChangeTriggerStatus },
                          model: {
                            value: _vm.triggerStatus,
                            callback: function ($$v) {
                              _vm.triggerStatus = $$v
                            },
                            expression: "triggerStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "系统关闭工单", value: "close" },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "转交第二处理人",
                              value: "transmit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.triggerStatus === "transmit"
                ? [
                    _c("div", { staticClass: "mb-10" }, [_vm._v("第二处理人")]),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("span", [_vm._v("选择处理人 ")]),
                            _c(
                              "el-select",
                              {
                                on: {
                                  change: function ($event) {
                                    ;(_vm.triggerList.secondProcessorId = []),
                                      _vm.secondProcessorTypeChange()
                                  },
                                },
                                model: {
                                  value: _vm.triggerList.secondProcessorType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.triggerList,
                                      "secondProcessorType",
                                      $$v
                                    )
                                  },
                                  expression: "triggerList.secondProcessorType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "门店角色", value: "role" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "指定用户", value: "user" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "secondProcessorId" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  multiple: "",
                                  "collapse-tags": "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.triggerList.secondProcessorId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.triggerList,
                                      "secondProcessorId",
                                      $$v
                                    )
                                  },
                                  expression: "triggerList.secondProcessorId",
                                },
                              },
                              _vm._l(
                                _vm.secondProcessorOptions,
                                function (option) {
                                  return _c("el-option", {
                                    key: option.id,
                                    attrs: {
                                      label: option.name || option.roleName,
                                      value: option.id,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", [_vm._v("处理人为空时 系统关闭工单")]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "detail-footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary", plain: "" },
              on: { click: _vm.goBack },
            },
            [_vm._v(" 取消 ")]
          ),
          _c(
            "el-button",
            {
              directives: [
                { name: "re-click", rawName: "v-re-click" },
                {
                  name: "loading",
                  rawName: "v-loading.fullscreen.lock",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                  modifiers: { fullscreen: true, lock: true },
                },
              ],
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.saveOrderRuleConfirm },
            },
            [_vm._v(" 保存 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }